import { Text } from '@savvy-kit/foundations/text';
import { EXTERNAL_ACCOUNT_DATA_DISCLOSURE } from 'src/constants/portfolio';

export function AccountsDisclosure() {
  return (
    <Text variant="caption" color="secondary">
      {EXTERNAL_ACCOUNT_DATA_DISCLOSURE}
    </Text>
  );
}
